export const createStreamBatcher = (intervalMs = 80) => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let pending: (() => void) | undefined;
  const flush = () => {
    if (timer !== undefined) clearTimeout(timer);
    timer = undefined;
    const operation = pending;
    pending = undefined;
    operation?.();
  };
  return {
    schedule(operation: () => void) {
      pending = operation;
      if (timer === undefined) timer = setTimeout(flush, intervalMs);
    },
    flush,
  };
};
